package com.essntl.features.invoice.ui.allinvoice.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import com.essntl.core.quickbooks.data.QuickbooksInvoice
import com.essntl.core.utils.viewmodel.State
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.iconbutton.tinted.EsSmallTintedIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.components.utils.spacing

@Composable
fun InvoicingActionButtons(
    qbInvoice: QuickbooksInvoice,
    loadingDownloadQuickbookIds: Set<String>,
    downloadQuickbooksInvoiceState: State<Pair<String, QuickbooksInvoice>>,
    onDownloadInvoice: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val uriHandler = LocalUriHandler.current

    Row(
        horizontalArrangement = Arrangement.spacedBy(1.spacing),
        modifier = modifier,
    ) {
        EsTooltip(
            text = "View in Quickbooks",
        ) {
            EsSmallOutlineIconButton(
                onClick = {
                    uriHandler.openUri(
                        uri = "https://app.qbo.intuit.com/app/invoice?txnId=${qbInvoice.Id}",
                    )
                },
                iconRes = EsIcons.Eye,
                enabled = true,
            )
        }

        EsTooltip(
            text = "Get as PDF",
        ) {
            EsSmallTintedIconButton(
                onClick = onDownloadInvoice,
                iconRes = EsIcons.Attachment,
                loading = qbInvoice.Id in loadingDownloadQuickbookIds,
                enabled = !downloadQuickbooksInvoiceState.isLoading,
            )
        }
    }
}